import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { navItemsForUser } from "@/lib/navigationConfig";
import { isNavItemActive } from "@/lib/navUtils";
import { cn } from "@/lib/utils";

const topNavLinkClassName = (active) =>
  cn(
    "relative inline-flex items-center gap-2 h-11 px-3 text-xs tracking-[0.15em] uppercase font-medium transition-colors",
    "border-b-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 focus-visible:ring-offset-dark-background",
    active
      ? "text-brand-primary border-brand-primary"
      : "text-dark-text-muted border-transparent hover:text-dark-text-primary hover:border-dark-border"
  );

export const TopNavigation = ({ className, coachPendingCount = 0 }) => {
  const location = useLocation();
  const { user } = useAuth();
  const items = navItemsForUser(user);

  return (
    <nav
      aria-label="Primary"
      data-testid="top-navigation"
      className={cn("hidden md:flex items-center gap-1 lg:gap-2 min-w-0", className)}
    >
      {items.map((item) => {
        const active = isNavItemActive(location.pathname, item.to, { end: item.end });
        const Icon = item.icon;
        return (
          <Link
            key={item.to}
            to={item.to}
            className={topNavLinkClassName(active)}
            data-testid={item.testId}
            aria-current={active ? "page" : undefined}
          >
            {Icon ? (
              <Icon
                className="w-4 h-4 shrink-0 hidden lg:inline-block"
                strokeWidth={1.5}
                aria-hidden="true"
              />
            ) : null}
            <span>{item.label}</span>
            {item.to === "/coach" && coachPendingCount > 0 && (
              <span
                className="ml-1 inline-flex min-w-[1.125rem] h-[1.125rem] items-center justify-center rounded-full bg-brand-primary px-1 text-[10px] font-semibold text-white"
                data-testid="nav-coach-pending-badge"
                aria-label={`${coachPendingCount} pending coach action`}
              >
                {coachPendingCount}
              </span>
            )}
          </Link>
        );
      })}
    </nav>
  );
};
